import e from "styled-components";
import s from "../../utils/colors.js";
import { device as o } from "../../utils/device.js";
import t from "../Text/index.js";
import n from "./Preview/items.js";
const a = e.div``, x = {
  Desktop: e.div`
    display: none;
    @media ${o.isDesktop} {
      display: ${(i) => i.$show.desktop ? "flex" : "none"};
    }
  `,
  Tablet: e.div`
    display: none;
    @media ${o.isTablet} {
      display: ${(i) => i.$show.tablet ? "flex" : "none"};
    }
  `,
  Mobile: e.div`
    display: none;
    @media ${o.isMobile} {
      display: ${(i) => i.$show.mobile ? "flex" : "none"};
    }
  `
}, $ = e(a)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${o.isDesktop}, ${o.isTablet} {
    max-width: ${(i) => i.$wrapperContainerMaxWidth}
  }
`, c = e(t.Heading.H3)`
  font-weight: bold;
  margin-bottom: 24px;

  @media ${o.isMobile} {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.21px;
  }
`, f = e(n)``, y = e(t.Body)`
  margin: 0 0 4px;

  + aside {
    border-top: 1px solid ${s.darkGrey10};
  }
`;
export {
  $ as Container,
  x as Display,
  y as ExceededMessage,
  f as Preview,
  c as TitleContainer
};
